import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Dropdown,
} from 'antd';
import './style.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faClose, faSearch, faTrashCan,
} from '@fortawesome/free-solid-svg-icons';
import { LoadingOutlined } from '@ant-design/icons';

/**
 *
 */
function SelectRole({
  getRoles, roles, onChange, tenantId, disabled, containerClassName,
  removeStep, parentKey, stepNumber, getRolesLoading, excludedRoles,
  selectedRole, innerComponent, createWorkflowV2Loading,
}) {
  const [keyword, setKeyword] = useState('');
  const [showRoles, setShowRoles] = useState(false);

  const handleOutsideClick = (event) => {
    if (event.target.closest('.ant-dropdown') === null) {
      setShowRoles(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    if (!roles && !getRolesLoading && getRoles) {
      getRoles(tenantId);
    }
  }, [tenantId]);

  return (
    <div className={containerClassName}>
      <div>
        <Dropdown
          overlay={(
            <div className="select-role__dropdown">
              <div className="select-role__dropdown-input">
                <div className="select-role__dropdown-padding" />
                <div className="select-role__dropdown-input-inner">
                  <FontAwesomeIcon icon={faSearch} />
                  <input value={keyword} onChange={(event) => setKeyword(event.target.value)} placeholder="search role.." />
                </div>
              </div>
              <div className="select-role__dropdown-list">
                {
                      roles?.data
                        ?.filter((item) => !excludedRoles.includes(item?.tenant_role_id))
                        ?.filter((item) => item?.tenant_role_name?.toLowerCase()?.includes(keyword?.toLowerCase()) || item?.last_name?.toLowerCase()?.includes(keyword?.toLowerCase()))
                        ?.map((item) => (
                          <div
                            className={`select-role__dropdown-item ${item?.tenant_role_id === selectedRole ? 'select-role__dropdown-item-selected' : ''}`}
                            onClick={() => {
                              onChange(item);
                              setShowRoles(false);
                            }}
                          >
                            {item?.tenant_role_name}
                            <span className="select-role__dropdown-item-close">
                              <FontAwesomeIcon icon={faClose} />
                            </span>
                          </div>
                        ))
                }
                { getRolesLoading && (
                  <div style={{ textAlign: 'center', marginTop: '50px' }}>
                    <LoadingOutlined />
                  </div>
                )}
              </div>
              {stepNumber && (
                <div className="select-role__remove" onClick={() => removeStep(parentKey, stepNumber)}>
                  {createWorkflowV2Loading ? <LoadingOutlined /> : <FontAwesomeIcon icon={faTrashCan} />}
                    &nbsp;Remove Approval Step
                </div>
              )}
            </div>
          )}
          placement="bottom"
          disabled={disabled}
          trigger={['click']}
          open={showRoles}
        >
          <div onClick={() => {
            if (!disabled) {
              setShowRoles(true);
            }
          }}
          >
            {innerComponent}
          </div>
        </Dropdown>
      </div>
    </div>
  );
}

const mapStateToProps = ({ UserReducers, WorkflowsReducers }) => ({
  user: UserReducers.user,
  roles: UserReducers.roles,
  createWorkflowV2Loading: WorkflowsReducers.createWorkflowV2Loading,
});

const mapDispatchToProps = (dispatch) => ({

});

SelectRole.propTypes = {
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  containerClassName: PropTypes.any,
  tenantId: PropTypes.any,
  getRoles: PropTypes.any,
  roles: PropTypes.any,
  getRolesLoading: PropTypes.bool,
  excludedRoles: PropTypes.array,
  removeStep: PropTypes.func,
  parentKey: PropTypes.string,
  stepNumber: PropTypes.number,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SelectRole));
